module.exports = __webpack_public_path__ + "static/media/back.5233e3a4.svg";